export default __webpack_public_path__ + "static/media/LaurenSchulze.410f54af.jpg";